exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-api-schema-modal .schema-helper[data-v-8a9077d4]{font-size:.875rem;line-height:1.5}.fts-api-schema-modal .schema-helper .schema-helper-list[data-v-8a9077d4]{padding-left:1.5rem}.fts-api-schema-modal .schema-helper .schema-helper-list>div[data-v-8a9077d4]{display:list-item}.fts-api-schema-modal .schema-container[data-v-8a9077d4]{font-size:.875rem;line-height:1.5;color:var(--fts-text)}.fts-api-schema-modal .schema-wrapper[data-v-8a9077d4]{margin-bottom:.5rem}.fts-api-schema-modal .schema-label[data-v-8a9077d4]{color:var(--fts-default)}", ""]);

// exports
